import { ConfigField } from '../../../../../types';
import { ApplicationState } from '../../../../../store';

type Fields = {
  courseFeeDepositReqd: string;
  courseFeeDeposit: number;
  courseFeeDepositDate: string;
  courseFeeDepositNotReqdReason: string;
  accomDepositReqd: string;
  accomDeposit: number;
  accomDepositDate: string;
};

type Visible = Record<
  | 'courseFeeDepositReqd'
  | 'courseFeeDeposit'
  | 'courseFeeDepositDate'
  | 'courseFeeDepositNotReqdReason'
  | 'accomDepositReqd'
  | 'accomDeposit'
  | 'accomDepositDate',
  boolean
>;

type Mandatory = Record<
  | 'courseFeeDepositReqd'
  | 'courseFeeDeposit'
  | 'courseFeeDepositDate'
  | 'courseFeeDepositNotReqdReason'
  | 'accomDepositReqd'
  | 'accomDeposit'
  | 'accomDepositDate',
  boolean
>;

export function getPageStatus(
  config: ApplicationState['config'],
  fields: Fields
): {
  complete: boolean;
  visible: Visible;
} {
  const {
    courseFeeDepositReqd,
    courseFeeDeposit,
    courseFeeDepositDate,
    courseFeeDepositNotReqdReason,
    accomDepositReqd,
    accomDeposit,
    accomDepositDate
  } = fields;

  const {
    DepositPaid: courseFeeDepositReqdConfig,
    DepositAmount: courseFeeDepositConfig,
    DepositDate: courseFeeDepositDateConfig,
    DepositReason: courseFeeDepositReasonConfig,
    AccommodationDepositPaid: accomDepositReqdConfig,
    AccommodationDepositAmount: accomDepositConfig,
    AccommodationDepositDate: accomDepositDateConfig
  }: {
    [key: string]: ConfigField;
  } = config.Checklist.Finances.Page1;

  const visible: Visible = {
    courseFeeDepositReqd: courseFeeDepositReqdConfig?.visible,
    courseFeeDeposit: courseFeeDepositConfig?.visible && courseFeeDepositReqd === 'Yes',
    courseFeeDepositDate: courseFeeDepositDateConfig?.visible && courseFeeDepositReqd === 'No',
    courseFeeDepositNotReqdReason:
      courseFeeDepositReasonConfig?.visible && courseFeeDepositReqd === 'No - Not Required',
    accomDepositReqd: accomDepositReqdConfig?.visible,
    accomDeposit: accomDepositConfig?.visible && accomDepositReqd === 'Yes',
    accomDepositDate: accomDepositDateConfig?.visible && accomDepositReqd === 'Not yet - I plan on paying one'
  };

  const mandatory: Mandatory = {
    courseFeeDepositReqd: courseFeeDepositReqdConfig?.mandatory,
    courseFeeDeposit: courseFeeDepositConfig?.mandatory,
    courseFeeDepositDate: courseFeeDepositDateConfig?.mandatory,
    courseFeeDepositNotReqdReason: courseFeeDepositReasonConfig?.mandatory,
    accomDepositReqd: accomDepositReqdConfig?.mandatory,
    accomDeposit: accomDepositConfig?.mandatory,
    accomDepositDate: accomDepositDateConfig?.mandatory
  };

  // prettier-ignore
  const complete: boolean =
    (!visible.courseFeeDepositReqd || !mandatory.courseFeeDepositReqd || courseFeeDepositReqd !== '') &&
    (!visible.courseFeeDeposit || !mandatory.courseFeeDeposit || courseFeeDeposit !== 0) &&
    (!visible.courseFeeDepositDate || !mandatory.courseFeeDepositDate || courseFeeDepositDate !== '') &&
    (!visible.courseFeeDepositNotReqdReason || !mandatory.courseFeeDepositNotReqdReason || courseFeeDepositNotReqdReason !== '') &&
    (!visible.accomDepositReqd || !mandatory.accomDepositReqd || accomDepositReqd !== '') &&
    (!visible.accomDeposit || !mandatory.accomDeposit || accomDeposit !== 0) &&
    (!visible.accomDepositDate || !mandatory.accomDepositDate || accomDepositDate !== '')

  return {
    complete,
    visible
  };
}
